import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cbe2672"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "Plaats"),
  /*#__PURE__*/_createElementVNode("td", null, "Brielle")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "Adres"),
  /*#__PURE__*/_createElementVNode("td", null, "Hoogaars 80")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "Postcode"),
  /*#__PURE__*/_createElementVNode("td", null, "3232 TG")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "Telefoonnummer"),
  /*#__PURE__*/_createElementVNode("td", null, "+31 6 3900 8814")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "E-mailadres"),
  /*#__PURE__*/_createElementVNode("td", null, "info@maatontwikkeling.nl")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "KvK-nummer"),
  /*#__PURE__*/_createElementVNode("td", null, "6024 9579")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "Btw-id"),
  /*#__PURE__*/_createElementVNode("td", null, "NL00 2330 557B 49")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "IBAN"),
  /*#__PURE__*/_createElementVNode("td", null, "NL13 KNAB 0259 9578 28")
], -1))
const _hoisted_9 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", null, _hoisted_9))
}